/// <reference path="../../../vendor/typings/angularjs/angular.d.ts" />
/// <reference path="../map/map.geometry.overlay.ts" />

module Eseebase {

    export class FileModel {
        id: string;
        fileName: string;
        fileUrl: string;
        extractOnlySelectedUnits: boolean;
        status: string;
        apartmentNumbers: string[];
        errors: string[];
        warnings: string[];
        selectedApartmentNumbers: string[];
        progress: number;
        associationNumber: string;
        departmentNumber: string;
        projectAddress: string;
        createdOn: string;
        projectGeoLocation: Coordinates;
        transparent: boolean;
        isDownloading: boolean;
        organizationalUnitId: string;
        parentOrganizationalUnitId: string;
        revitVersion: string;
        localizer: string;
        isRerunScheduled: boolean;
        customerNumber: string;
        detailsExpanded: boolean;
        latestActions: EventHistoryViewModel[];
        ifcUrl: string;
        extractOnlySimData: boolean;
        hasOutdoorGeometry: boolean;
        hasApartmentsGeometry: boolean;
        hasRoomGeometry: boolean;
        expanded: boolean;
        hasWarnings: boolean;
        showInCanea: boolean;
        constructor() {
            this.status = FileStatus[FileStatus.New];
        }
    }

    export class FileCoordinate {
        fileId: string;
        coordinates: string;
        companyName: string;
        geometryFaces: TriangulatedFace[];
        overlay: MapGeometryOverlay;
        mapLayerUrl: string;
        isLandscape: boolean;
        hasDrawings: boolean;
    }

    export class ModelFilterItemViewModel {
        constructor(public groupBy: boolean, public values: string[]) { }
        public any() { return this.values != null && this.values.length > 0; }
        public isEmpty() { return !this.groupBy && !this.any();}
    }

    export class ModelFilterViewModel {
        association: ModelFilterItemViewModel;
        department: ModelFilterItemViewModel;
        localizer: ModelFilterItemViewModel;
        apartment: ModelFilterItemViewModel;
        indoorBuildingPartType: ModelFilterItemViewModel;
        simFamilyTypeName: ModelFilterItemViewModel;
        category: ModelFilterItemViewModel;
        function: ModelFilterItemViewModel;
        orientation: ModelFilterItemViewModel;
        outdoorLevel: ModelFilterItemViewModel;
        simLevel: ModelFilterItemViewModel;
        surfaceMaterial: ModelFilterItemViewModel;
        keynote: ModelFilterItemViewModel;
        simArea: ModelFilterItemViewModel;
        status: string;
        modelType: string;
        createdAfter: Date;
        createdBefore: Date;
        issueDateAfter: Date;
        issueDateBefore: Date;
        pageSize: number | null;
        constructor() {
            this.association = new ModelFilterItemViewModel(false, null);
            this.department = new ModelFilterItemViewModel(false, null);
            this.localizer = new ModelFilterItemViewModel(false, null);
            this.apartment = new ModelFilterItemViewModel(false, null);
            this.simFamilyTypeName = new ModelFilterItemViewModel(true, null);
            this.indoorBuildingPartType = new ModelFilterItemViewModel(true, null);
            this.category = new ModelFilterItemViewModel(true, null);
            this.function = new ModelFilterItemViewModel(false, null);
            this.orientation = new ModelFilterItemViewModel(false, null);
            this.outdoorLevel = new ModelFilterItemViewModel(false, null);
            this.simLevel = new ModelFilterItemViewModel(false, null);
            this.surfaceMaterial = new ModelFilterItemViewModel(false, null);
            this.keynote = new ModelFilterItemViewModel(false, null);
            this.simArea = new ModelFilterItemViewModel(false, null);
            this.status = 'All';
            this.modelType = 'All';
            this.createdAfter = null;
            this.createdBefore = null;
            this.issueDateAfter = null;
            this.issueDateBefore = null;
            this.pageSize = null;
        }
        public isEmpty() {
            return this.localizer.isEmpty() && this.apartment.isEmpty() && this.indoorBuildingPartType.isEmpty() &&
                this.category.isEmpty() && this.keynote.isEmpty() &&
                this.function.isEmpty() && this.orientation.isEmpty() && this.outdoorLevel.isEmpty() &&
                this.simLevel.isEmpty() && this.surfaceMaterial.isEmpty() && this.simFamilyTypeName.isEmpty() && this.simArea.isEmpty();
        }
        public copyFrom(filter: ModelFilterViewModel) {
            this.association = new ModelFilterItemViewModel(filter.association.groupBy, filter.association.values);
            this.department = new ModelFilterItemViewModel(filter.department.groupBy, filter.department.values);
            this.localizer = new ModelFilterItemViewModel(filter.localizer.groupBy, filter.localizer.values);
            this.apartment = new ModelFilterItemViewModel(filter.apartment.groupBy, filter.apartment.values);
            this.indoorBuildingPartType = new ModelFilterItemViewModel(true, filter.indoorBuildingPartType.values);
            this.category = new ModelFilterItemViewModel(true, filter.category.values);
            this.function = new ModelFilterItemViewModel(filter.function.groupBy, filter.function.values);
            this.orientation = new ModelFilterItemViewModel(filter.orientation.groupBy, filter.orientation.values);
            this.outdoorLevel = new ModelFilterItemViewModel(filter.outdoorLevel.groupBy, filter.outdoorLevel.values);
            this.simLevel = new ModelFilterItemViewModel(filter.simLevel.groupBy, filter.simLevel.values);
            this.surfaceMaterial = new ModelFilterItemViewModel(filter.surfaceMaterial.groupBy, filter.surfaceMaterial.values);
            this.simFamilyTypeName = new ModelFilterItemViewModel(true, filter.simFamilyTypeName.values);
            this.keynote = new ModelFilterItemViewModel(filter.keynote.groupBy, filter.keynote.values);
            this.simArea = new ModelFilterItemViewModel(filter.simArea.groupBy, filter.simArea.values);
            this.status = filter.status;
            this.modelType = filter.modelType;

            this.createdAfter = this.stringToDate(filter.createdAfter);
            this.createdBefore = this.stringToDate(filter.createdBefore);
            this.issueDateAfter = this.stringToDate(filter.issueDateAfter);
            this.issueDateBefore = this.stringToDate(filter.issueDateBefore);
        }

        public stringToDate(date: any) {
            if (date == null) {
                return null;
            }
            if (typeof date === 'string') {
                var dateSplit = date.split('T');
                var dateParts = dateSplit[0].split('-');
                var timeParts = dateSplit[1].split(':');
                return new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]), parseInt(timeParts[0]), parseInt(timeParts[1]), parseInt(timeParts[2]));
            }
            return date;
        }
    }

    export class ResultFilterModel {
        associationIds: string[];
        departmentIds: string[];
        localizers: string[];
        keywords: string[];
        createdAfter: string;
        createdBefore: string;
        issueDateAfter: string;
        issueDateBefore: string;
        pageSize: number | null;
        constructor() {
            this.keywords = [];
            this.pageSize = 10;
        }
    }

    export class FilterSelectors {
        categories: string[];
        functions: string[];
        keynotes: string[];
        orientations: string[];
        outdoorLevels: string[];
        simLevels: string[];
        simFamilyTypeNames: string[];
    }

    export class Coordinates {
        latitude: number;
        longitude: number;
        constructor(asString: string) {
            if (asString == null || asString.indexOf(',') < 0) {
                return;
            }
            var split = asString.split(',');

            this.latitude = parseFloat(split[0].trim());
            this.longitude = parseFloat(split[1].trim());
        }
        public almostEquals(comapreWith: google.maps.LatLng) {
            var threshold = 0.000001;
            return Math.abs(this.latitude - comapreWith.lat()) < threshold && Math.abs(this.longitude - comapreWith.lng()) < threshold;
        }
        public toGoogle() {
            return new google.maps.LatLng(this.latitude, this.longitude);
        }
        public static almostEqual(location1: google.maps.LatLng, location2: google.maps.LatLng) {
            if (location1 == null && location2 == null) {
                return true;
            }
            if (location1 == null || location2 == null) {
                return false;
            }
            var threshold = 0.000001;
            return Math.abs(location1.lat() - location2.lat()) < threshold && Math.abs(location1.lng() - location2.lng()) < threshold;
        }
    }

    export class IndoorDataAgregated {
        fact: string;
        total: number;
        roomMeasure: RoomMeasure[];
        groups: IndoorDataAgregated[];
    }

    export class IndoorDataResponse {
        data: IndoorDataPagedResult;
        buildingParts: IndoorDataAgregated[];
        roomTypes: RoomTypeViewModel[];
    }

    export class UploadEventArgs {
        companyNumber: string;
        associationNumber: string;
        departmentNumber: string;
        associationId: string;
        departmentId: string;
        localizer: any;
        apartmentNumber: any;
        hyperlink: string;
        extractSelectedUnits: boolean;
        extractOnlySimData: boolean;
        fileId: string;
        fileNames: string[];
        formData: FormData;
        constructor() {
            this.formData = null;
        }
    }

    export class IndoorDataPagedResult {
        pageNumber: number;
        totalNumberOfPages: number;
        totalNumberOfRecords: number;
        results: IndoorDataAgregated[];
        constructor() {
            this.results = [];
            this.totalNumberOfRecords = -1;
        }
        public isLastPage() {
            return this.pageNumber >= this.totalNumberOfPages;
        }
    }

    export class FilePagedResult {
        pageNumber: number;
        totalNumberOfPages: number;
        totalNumberOfRecords: number;
        results: FileModel[];
        constructor() {
            this.results = [];
            this.totalNumberOfRecords = -1;
        }
        public isLastPage() {
            return this.pageNumber >= this.totalNumberOfPages;
        }
    }

    export class MainDrawingPagedResult {
        pageNumber: number;
        totalNumberOfPages: number;
        totalNumberOfRecords: number;
        scrollId: string;
        results: MainDrawingViewModel[];
        constructor() {
            this.results = [];
            this.totalNumberOfRecords = -1;
        }
        public isLastPage() {
            return this.pageNumber >= this.totalNumberOfPages;
        }
    }

    export class MainDrawingViewModel {
        url: string;
        modelName: string;
        companyNumber: number;
        associationNumber: string;
        departmentNumber: string;
        localizer: string;
        previews: DrawingViewModel[];
        menuExpanded: boolean;
        secondaryDrawingUrl: string;
    }

    export class ScannedImagePagedResult {
        pageNumber: number;
        totalNumberOfPages: number;
        totalNumberOfRecords: number;
        results: ScannedImageViewModel[];
        constructor() {
            this.results = [];
            this.totalNumberOfRecords = -1;
        }
        isLastPage: boolean;
    }

    export class ScannedImageViewModel {
        companyNumber: string;
        companyName: string;
        associationNumber: string;
        departmentNumber: string;
        localizer: string;
        address: string;
        menuExpanded: boolean;
        images: DrawingViewModel[];
    }

    export class DrawingViewModel {
        id: string;
        url: string;
        previewUrl: string;
        fileName: string;
        modelName: string;
        isUploading: boolean;
        mainDrawingUrl: string;
        isDwf: boolean;
    }

    export class OutdoorDataAggregated {
        fact: string;
        totalArea: string;
        totalLength: string;
        totalQuantity: string;
        totalPerimeter: string;
        groups: OutdoorDataAggregated[];
    }

    export class SimDataAggregated {
        fact: string;
        area: string;
        length: string;
        perimeter: string;
        unconnectedHeight: string;
        computedCount: string;
        groups: SimDataAggregated[];
    }

    export class EventHistoryViewModel {
        timestamp: string;
        event: string;
        userName: string;
    }

    export class RoomMeasure {
        roomNumber: string;
        measure: number
    }

    export class FileDetailsViewModel {
        companyName: string;
        associationName: string;
        departmentName: string;
        localizer: string;
        createDate: string;
        revitVersion: string;
        isRerunScheduled: boolean;
        history: EventHistoryViewModel[];
    }

    export class UploadingErrorPagedResult {
        results: UploadingErrorViewModel[];
        totalNumberOfRecords: number;
        constructor() {
            this.results = [];
            this.totalNumberOfRecords = -1;
        }
        hasAddressMissmatch: boolean;
    }

    export class UploadingErrorViewModel {
        text: string;
        stopProcessing: boolean;
    }

    export class MapSettings {
        public showBuildingLocalizers: boolean;
        public showLandscapeLocalizers: boolean;
        public showLocalizersWithDrawings: boolean;
        public showLocalizersWithoutDrawings: boolean;
        public showBuildingOverlay: boolean;
        public showLandscapeOverlay: boolean;
        public isSattelite: boolean;
        constructor() {
            this.showBuildingLocalizers = true;
            this.showLandscapeLocalizers = true;
            this.showLocalizersWithDrawings = true;
            this.showLocalizersWithoutDrawings = true;
            this.showBuildingOverlay = true;
            this.showLandscapeOverlay = true;
            this.isSattelite = false;
        }
    }

    export enum FileStatus {
        New = 0,
        Uploading,
        Uploaded,
        Verifying,
        Verified,
        Extracting,
        Extracted,
        Error,
        Duplicate,
        Reserved_9,  // Used for 'StopQueue' command
        Reserved_10, // Used for 'ExportDrawings' command
        Creating,
        Created
    }

    export enum StatusMode {
        Progress = 0,
        Warning,
        Completed
    }
}
